const $ = jQuery.noConflict()

class Slider {
	constructor(selector, args = {}) {
		this.selector = selector
		this.args = args
	}

	getDefaultSlickSettings() {
		return {
			dots: false,
			arrows: true,
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			pauseOnHover: false,
			speed: 600,
		}
	}

	/**
	 * Override our default slick settings with args provided to the class.
	 */
	getSlickSettings() {
		return Object.assign({}, this.getDefaultSlickSettings(), this.args)
	}

	init() {
		$(this.selector).on('setPosition', () => {
			$(this.selector).find('figcaption').each((i, item) => {
				const caption = $(item);
				const width = caption.closest('figure').find('img').width();
				caption.css('max-width', width > 0 ? `${width}px` : '');
			});
		});

		let settings = this.getSlickSettings();

		if (!$(this.selector).hasClass('slick-initialized')) {
			$(this.selector).slick(settings);
		}
	}
}

const SimpleSlider = new Slider('.gallery-slider__slider')
const TestimonialSlider = new Slider('.testimonial-slider')
const FeaturedTripsSlider = new Slider('.block-featured-trips-slider__slider', {
    slidesToShow: 3,
    responsive: [
        {
            breakpoint: 1320,
            settings: {
                slidesToShow: 2,
            },
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
            },
        },
    ],
})
const AwardsSlider = new Slider('.block-awards-slider__slider', {
	slidesToShow: 3,
	responsive: [
		{
			breakpoint: 992,
			settings: {
				slidesToShow: 2,
			},
		},
		{
			breakpoint: 768,
			settings: {
				slidesToShow: 1,
			},
		},
	],
})

const DestinationHeroSlider = new Slider('.destination-hero-slider')
const FluidSlider = new Slider(
	'.gallery-slider__slider-fluid',
	{
		centerMode: true,
		variableWidth: true,
	}
)
export { SimpleSlider, TestimonialSlider, FeaturedTripsSlider, AwardsSlider, FluidSlider, DestinationHeroSlider }
